<template>
  <div>
    <div
      class="link-wrapper"
      style="background-color: white !important"
      :style="{
        padding: cardPadding.padding,
        'border-radius': indexMode ? '0.25rem' : '0',
        'border-top': !cardStyle
          ? indexMode || idx != 0
            ? 'none'
            : '1px solid #e1dbc7'
          : 'none',
        'border-bottom': !cardStyle
          ? indexMode
            ? 'none'
            : '1px solid #e1dbc7'
          : 'none',
      }"
      :class="{
        'mb-2': indexMode && idx !== newsLength - 1,
      }"
    >
      <div
        v-if="!cardStyle"
        class="text-green"
        @click="$emit('select', news.id)"
      >
        <div class="d-flex align-items-center justify-content-between w-100">
          <div class="d-flex w-100 text-ellipsis">
            <div
              class="d-flex align-items-center w-100 text-ellipsis"
              :class="{
                'flex-wrap': isLessThanMd,
              }"
            >
              <span class="me-4">{{
                isoFormat(news.publishedAt, "yyyy.MM.dd")
              }}</span>
              <div
                class="d-flex flex-column me-4"
                :class="{
                  'narrow-label-chip-padding': isUserPage,
                }"
              >
                <NewsLabelChip
                  :label="labelTranslater(news.label)"
                  :reverseColor="reverseColor"
                />
                <NewsLabelChip
                  v-if="isUserPage"
                  :label="news.forMembers ? '会員向け' : '一般公開'"
                  :reverseColor="reverseColor"
                />
              </div>

              <span
                style="
                  min-width: 150px;
                  color: #333;
                  font-weight: 100;
                  max-width: 450px;
                "
                class="text-ellipsis"
                :class="{
                  'w-100': isLessThanMd,
                  'mt-2': isLessThanMd,
                }"
                >{{ news.title }}</span
              >
            </div>
            <div v-if="withContent" class="mt-2 with-list-padding">
              <span v-html="news.content"></span>
            </div>
          </div>
          <div class="d-flex align-items-center">
            <i
              v-if="news.nowPinned"
              class="pi pi-thumbtack text-danger me-2"
            ></i>
            <Tag v-if="news.unread" class="new-tag animate-blink" />
            <i class="pi pi-angle-right icon-md"></i>
          </div>
        </div>
      </div>
      <Card v-else>
        <template #content>
          <div class="text-green" @click="$emit('select', news.id)">
            <div
              class="d-flex align-items-center justify-content-between w-100"
            >
              <div class="d-flex w-100 text-ellipsis">
                <div
                  class="d-flex align-items-center w-100 text-ellipsis"
                  :class="{
                    'flex-wrap': isLessThanMd,
                  }"
                >
                  <span class="me-4">{{
                    isoFormat(news.publishedAt, "yyyy.MM.dd")
                  }}</span>
                  <div
                    class="d-flex flex-column me-4"
                    :class="{
                      'narrow-label-chip-padding': isUserPage,
                    }"
                  >
                    <NewsLabelChip
                      :label="labelTranslater(news.label)"
                      :reverseColor="reverseColor"
                    />
                    <NewsLabelChip
                      v-if="isUserPage"
                      :label="news.forMembers ? '会員向け' : '一般公開'"
                      :reverseColor="reverseColor"
                    />
                  </div>

                  <span
                    style="
                      min-width: 150px;
                      color: #333;
                      font-weight: 100;
                      max-width: 450px;
                    "
                    class="text-ellipsis"
                    :class="{
                      'w-100': isLessThanMd,
                      'mt-2': isLessThanMd,
                    }"
                    >{{ news.title }}</span
                  >
                </div>
                <div v-if="withContent" class="mt-2 with-list-padding">
                  <span v-html="news.content"></span>
                </div>
              </div>
              <div class="d-flex align-items-center">
                <i
                  v-if="news.nowPinned"
                  class="pi pi-thumbtack text-danger me-2"
                ></i>
                <Tag v-if="news.unread" class="new-tag animate-blink" />
                <i class="pi pi-angle-right icon-md"></i>
              </div>
            </div>
          </div>
        </template>
      </Card>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useMqUtils } from "/@/vue/composables";
import { isoFormat } from "/@/modules/luxon";
import { labelTranslater } from "/@/modules/news";
import { NewsLabelChip } from "/@/vue/components/Atom";
import { NewsClient } from "/@/types";
import Tag from "primevue/tag";
import Card from "primevue/card";
import { computed } from "vue";

const props = defineProps<{
  news: NewsClient;
  newsLength: number;
  idx: number;
  indexMode?: boolean;
  reverseColor?: boolean;
  withContent?: boolean;
  isUserPage?: boolean;
  isMember?: boolean;
  cardStyle?: boolean;
}>();

defineEmits<{
  (e: "select", id: number): void;
}>();

const { isLessThanMd } = useMqUtils();

// !cardStyle
// padding: indexMode ? '0.35rem 1.25rem' : '1rem 1.25rem',
// cardStyle
// padding: indexMode ? '0.25rem 1.25rem' : '0.5rem 1.25rem',

const cardPadding = computed(() => {
  return {
    padding: props.cardStyle
      ? props.indexMode
        ? "0.25rem 1.25rem"
        : "0.5rem 1.25rem"
      : props.indexMode
      ? "0.35rem 1.25rem"
      : "1rem 1.25rem",
  };
});
</script>

<style lang="scss">
.narrow-label-chip-padding {
  .p-chip {
    .p-chip-text {
      margin: 0;
    }
  }
}

.link-wrapper {
  .p-card {
    background-color: lighten(rgb(242, 238, 233), 5%);
  }
}
</style>
